import React from 'react';
import CheckboxUncheckedIcon from '@/components/Icons/CheckboxUncheckedIcon';
import CheckboxCheckedIcon from '@/components/Icons/CheckboxCheckedIcon';
import { Checkbox, Description, Field } from '@headlessui/react';

export function CheckboxField({
  label,
  checked,
  onChange,
  link
}: {
  label: string | React.ReactNode;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  link?: { url: string; text: string };
}) {
  const handleChange = (isChecked: boolean) => {
    const syntheticEvent = {
      target: {
        checked: isChecked,
        type: 'checkbox',
        name: 'checkbox'
      }
    } as React.ChangeEvent<HTMLInputElement>;

    onChange(syntheticEvent);
  };

  return (
    <Field className="flex items-center justify-center space-x-3 mt-16">
      <Checkbox checked={checked} onChange={handleChange} className="group cursor-pointer">
        <CheckboxUncheckedIcon className="block group-data-[checked]:hidden" />
        <CheckboxCheckedIcon className="hidden group-data-[checked]:block" />
      </Checkbox>
      <Description
        className="select-none text-sm text-gray-700 text-center cursor-pointer"
        onClick={() => handleChange(!checked)}
      >
        {label}
        {link && (
          <>
            {' '}
            <a
              href={link.url}
              className="text-pink-600 hover:text-pink-700"
              onClick={(e) => e.stopPropagation()}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.text}
            </a>
          </>
        )}
      </Description>
    </Field>
  );
}
